const API_URL = 'http://localhost:5001';
export default API_URL;
